import { ICMenuRelation } from "./icmenurelation";
import { ICRoleMenu } from "./icrolemenu";

export class ICMenu {
  Childrens: ICMenuRelation[];
  Code: string;
  Fathers: ICMenuRelation[];
  Icon: string;
  Id: number;
  IdGuid: string;
  Name: string;
  Order: number;
  RoleMenus: ICRoleMenu[];
  Title: boolean;
  Url: string;

  constructor(data?: Partial<ICMenu>) {
    Object.assign(this, data);
  }
}
